/**
 * Shared sessionStorage keys + events for saved strategies (used by Aged Care, SAH, Service Builder).
 * Keep this file free of Support-at-Home or Aged-Care feature imports so all modules can import it safely.
 */

export const HOME_CARE_STRATEGIES_KEY = 'careCompanionStrategies';
export const ACTIVE_HOME_CARE_STRATEGY_ID_KEY = 'careCompanionActiveHomeCareStrategyId';
export const HOME_CARE_STRATEGIES_UPDATED_EVENT = 'careCompanionHomeCareStrategiesUpdated';

export const SERVICE_BUILDER_HC_PREFIX = 'hc:';
export const SERVICE_BUILDER_AC_PREFIX = 'ac:';

export function notifyHomeCareStrategiesUpdated(): void {
    if (typeof window === 'undefined') return;
    window.dispatchEvent(new Event(HOME_CARE_STRATEGIES_UPDATED_EVENT));
}

export function setActiveHomeCareStrategyId(strategyId: string | null | undefined): void {
    if (typeof window === 'undefined') return;
    if (strategyId) {
        window.sessionStorage.setItem(ACTIVE_HOME_CARE_STRATEGY_ID_KEY, strategyId);
    } else {
        window.sessionStorage.removeItem(ACTIVE_HOME_CARE_STRATEGY_ID_KEY);
    }
}

export type ServiceBuilderSelectionKind = 'baseline' | 'aged_care' | 'home_care' | string;

export function formatServiceBuilderSelectionId(kind: ServiceBuilderSelectionKind, rawId: string | number | null | undefined): string {
    if (kind === 'baseline' || !rawId) return 'baseline';
    if (kind === 'aged_care') return `${SERVICE_BUILDER_AC_PREFIX}${rawId}`;
    return `${SERVICE_BUILDER_HC_PREFIX}${rawId}`;
}
